module.exports = __webpack_public_path__ + "4571f16fd4ef762c2ec79d272a3e27a9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/chat-bubble.png
 ** module id = 572
 ** module chunks = 0
 **/